const env = {
	apiUrl: 'https://ace-vault.azure-api.net/',
	clientId: 'F07C7E93-ED26-4E6A-92E1-B77A26BBFF6E',
	azureAppClientId: 'e89806a0-d43b-4631-b368-d1d65ab7000d'
}
export default  env;